// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3vq64","footer":"ChangeClinic_footer__21ruK"};